import React, { Component } from 'react'
import moment from 'moment-timezone'
import DayItem from './DayItem/DayItem'
import DaySelectionNav from './Navigation/Navigation'
import Loading from 'cogsworth/components/Loading/Loading'

import './DaySelection.css'
import { availableTimesBetween } from 'cogsworth/utils/availableTimes'
import { getLookupStartLimit } from 'cogsworth/utils/limits'

class DaySelection extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      days: [],
      startingDate: props.startingDate,
    }

    this.setup = this.setup.bind(this)
    this.getDays = this.getDays.bind(this)
  }

  componentDidMount(){
    this.setState({ loading: true }, () => {
      // Nesting the setup call in a setTimeout with a delay of 0ms
      // immediately executes the function without blocking the UI
      setTimeout(() => this.setup(this.props), 0)
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ loading: true }, () => {
      // Nesting the setup call in a setTimeout with a delay of 0ms
      // immediately executes the function without blocking the UI
      setTimeout(() => this.setup(nextProps), 0)
    })
  }

  setup(props) {
    let { startingDate, daysCount } = props

    const days = this.getDays({ availableTimes: props.availableTimes, startingDate, daysCount })

    this.setState({
      days,
      startingDate,
      loading: props.loading,
    })
  }

  getDays({ availableTimes, startingDate, daysCount }) {
    const days = []
    for(let i = 0; i < daysCount; i++) {
      const date = startingDate.clone().add(i, 'days')
      const dateTo = startingDate.clone().add(i + 1, 'days').subtract(1, 'millisecond')

      days.push({
        date,
        availableTimes: availableTimesBetween({
          availableTimes,
          dateFrom: date.toISOString(),
          dateTo: dateTo.toISOString()
        }),
      })
    }

    return days
  }

  render() {
    const { calendarView } = this.props
    const { startingDate, loading, days } = this.state

    if (loading) {
      return <Loading size="small" relative={true} />
    }

    const navPrev = !startingDate.isBefore(getLookupStartLimit())
    const endDate = moment(startingDate).add(this.props.daysCount, 'days').toISOString()
    const navNext = endDate < this.props.maxAvailabilityLookupDate

    return (
      <div className="day-selection">
        <DaySelectionNav onNav={this.props.onNav} navPrev={navPrev} navNext={navNext} calendarView={calendarView} />
        {
          days.map(dayItem => (
            <DayItem key={dayItem.date.toISOString()} {...dayItem} loading={loading} />
          ))
        }
      </div>
    )
  }
}

export default DaySelection
